<template>
    <div>
        <ion-toolbar>
            <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length && $route.name == 'auth_billing_name'">
                <ion-button class="button_back" @click="goBack">
                    <ion-icon name="arrow-back-outline"></ion-icon>
                </ion-button>
            </ion-buttons>
            <ion-buttons slot="end" v-if="$route.name == 'auth_billing_name'">
                <ion-button @click="skip">
                    <span>Skip</span>
                </ion-button>
            </ion-buttons>
        </ion-toolbar>

        <div class="main_wrapper ion-padding">
            <div class="container">
                <page-title title="Create Profile" subtitle="Please enter your details and upload your profile picture!"
                    showIcon />
                <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
                    :ref="el => formsData.userForm.ref = el" :label-position="'top'" @submit.prevent="save('userForm')">
                    <!-- <div class="form_text" v-if="$route.name != 'auth_billing_name'">
                        <div class="text">
                            {{ pageText[userRole].formText }}
                        </div>
                    </div> -->

                    <div>
                        <div class="user">
                            <div v-if="croppedImageUrl" class="preview">

                                <!-- <el-image :src="croppedImageUrl" class="preview-img"></el-image> -->
                                <preview :width="140" :height="140" :image="canvasOriginalAll.image"
                                    :coordinates="canvasOriginalAll.coordinates" />
                            </div>
                            <div v-else>

                                <el-avatar :size="'large'" :shape="'square'" icon="el-icon-user-solid"></el-avatar>
                            </div>
                            <!-- <i class="el-icon-camera" @click="$refs.FileInput.click"></i> -->
                            <div class="camera-icon" @click="$refs.FileInput.click">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M6.75992 22H17.2399C19.9999 22 21.0999 20.31 21.2299 18.25L21.7499 9.99C21.8899 7.83 20.1699 6 17.9999 6C17.3899 6 16.8299 5.65 16.5499 5.11L15.8299 3.66C15.3699 2.75 14.1699 2 13.1499 2H10.8599C9.82992 2 8.62992 2.75 8.16992 3.66L7.44992 5.11C7.16992 5.65 6.60992 6 5.99992 6C3.82992 6 2.10992 7.83 2.24992 9.99L2.76992 18.25C2.88992 20.31 3.99992 22 6.75992 22Z"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M10.5 8H13.5" stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M12 18C13.79 18 15.25 16.54 15.25 14.75C15.25 12.96 13.79 11.5 12 11.5C10.21 11.5 8.75 12.96 8.75 14.75C8.75 16.54 10.21 18 12 18Z"
                                        stroke="white" stroke-width="1.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </div>
                            <input ref="FileInput" type="file" style="display: none;" @click="$event.target.value = ''"
                                @change="onFileSelect" accept="image/*" />
                        </div>
                        <el-dialog v-model="dialog" width="700px" @open="openModal" @close="closeModal"
                            destroy-on-close>
                            <el-card>
                                <el-card-content>
                                    <div class="cropper-wrapper">
                                        <cropper v-if="selectedFile" ref="cropper" :src="selectedFile"
                                            :stencil-props="{ aspectRatio: 1 }" class="cropper" :debounce="false"
                                            :stencil-component="userRole == 'locum' ? CircleStencil : RectangleStencil">
                                        </cropper>

                                    </div>
                                </el-card-content>
                                <el-card-footer>
                                    <el-button class="pop-up-tm" type="primary" @click="cropImage">Save</el-button>
                                    <el-button class="cancel-btn-only" @click="closeModal">Cancel</el-button>
                                </el-card-footer>
                            </el-card>
                        </el-dialog>
                    </div>
                    <!-- PHARMACY -->
                    <template v-if="userRole == 'pharmacy' && isAustralia === true">
                        <template v-if="$route.name != 'auth_billing_name'">
                            <!-- <el-form-item :label="pageText[userRole].placeholders.name" prop="name" :required='true'> -->
                            <el-form-item label="What is the name of your company/employer?" prop="name"
                                :required='true'>
                                <el-input v-model="formsData.userForm.name.value" autocomplete="off"
                                    :placeholder="pageText[userRole].placeholders.name" :maxlength="75"
                                    @keyup="formsData.userForm.name.value = $event.target.value"></el-input>
                            </el-form-item>
                            <el-form-item label="Select company/employer type" prop="pharmacyType" :required='true'>
                                <el-select popper-class="normal-select" class="w-100" 
                                    v-model="formsData.userForm.pharmacyType.value"
                                    placeholder="Select Company/Employer type" @change="fetchAdditionalData" :popper-append-to-body="true">
                                    <el-option v-for="fieldData in pharmacyTypes" :key="fieldData.id"
                                        :label="fieldData.name" :value="fieldData.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item v-if="additionalOptions.length > 0" label="Select company/employer sub type" prop="additionalData">
                                <el-select popper-class="normal-select" class="w-100" v-model="formsData.userForm.additionalData.value"
                                    placeholder="Select an option" >
                                    <el-option v-for="item in additionalOptions" :key="item.id"
                                        :label="item.name" :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                        <template v-else>
                            <el-form-item label="What is the name of your company/employer?" :prop="'businessName'"
                                :required='true'>
                                <el-input v-model="formsData.userForm.businessName.value" autocomplete="off"
                                    :placeholder="pageText[userRole].placeholders.businessName" :maxlength="40"
                                    @keyup="formsData.userForm.businessName.value = $event.target.value"
                                    :disabled="formsData.userForm.businessName.disabled"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-checkbox v-model="formsData.userForm.businessName.disabled"
                                    @change="onNameCheckboxChange">Same as Business Name</el-checkbox>
                            </el-form-item>
                        </template>
                        <el-form-item v-if="isAustralia" label="Provide your Australian Business Number to proceed."
                            prop="abn" :required='true' class="is-no-asterisk el-input">
                            <input type="tel" class="el-input__inner" :ref='el => formsData.userForm.abn.ref = el'
                                :value="formsData.userForm.abn.value" :placeholder="'00 000 000 000'"
                                v-imask="formsData.userForm.abn.mask"
                                @accept="onFormMaskAccept($event, 'userForm', 'abn')"
                                @blur="checkFormValidation('userForm', true, 'abn')">
                        </el-form-item>
                    </template>
                    <template v-if="userRole == 'pharmacy' && isUS === true">
                        <template v-if="$route.name != 'auth_billing_name'">
                            <!-- <el-form-item :label="pageText[userRole].placeholders.name" prop="name" :required='true'> -->
                            <el-form-item label="What is the name of your company/employer?" prop="name"
                                :required='true'>
                                <el-input v-model="formsData.userForm.name.value" autocomplete="off"
                                    :placeholder="pageText[userRole].placeholders.name" :maxlength="75"
                                    @keyup="formsData.userForm.name.value = $event.target.value"
                                    @blur="checkFormValidation('userForm', true)"></el-input>
                            </el-form-item>
                            <el-form-item label="Select company/employer type" prop="pharmacyType" :required='true'>
                                <el-select popper-class="normal-select" class="w-100"
                                    v-model="formsData.userForm.pharmacyType.value"
                                    placeholder="Select Company/Employer type" @change="fetchAdditionalData"
                                    :popper-append-to-body="true">
                                    <el-option v-for="fieldData in pharmacyTypes" :key="fieldData.id"
                                        :label="fieldData.name" :value="fieldData.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <!-- Conditional Second Select -->
                            <el-form-item v-if="additionalOptions.length > 0" label="Select company/employer sub type"
                                prop="additionalData">
                                <el-select popper-class="normal-select" class="w-100"
                                    v-model="formsData.userForm.additionalData.value" placeholder="Select an option"
                                    @change="checkFormValidation('userForm')">
                                    <el-option v-for="item in additionalOptions" :key="item.id" :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                        <template v-else>
                            <el-form-item label="What is the name of your company/employer?" :prop="'businessName'"
                                :required='true'>
                                <el-input v-model="formsData.userForm.businessName.value" autocomplete="off"
                                    :placeholder="pageText[userRole].placeholders.businessName" :maxlength="40"
                                    @keyup="formsData.userForm.businessName.value = $event.target.value"
                                    :disabled="formsData.userForm.businessName.disabled"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-checkbox v-model="formsData.userForm.businessName.disabled"
                                    @change="onNameCheckboxChange">Same as Business Name</el-checkbox>
                            </el-form-item>
                        </template>
                    </template>
                    <!-- LOCUM -->
                    <template v-else>
                        <el-form-item prop="preferred_name">
                            <el-input v-model="formsData.userForm.preferred_name.value" autocomplete="off"
                                placeholder="Preferred Name" :maxlength="20" @keyup="
                            formsData.userForm.preferred_name.value = $event.target.value
                            ">
                                <template #prefix>
                                    <i class="el-icon-user"></i>
                                </template></el-input>
                        </el-form-item>
                        <!-- <el-form-item class="no-scroll" :label="pageText[userRole].placeholders.firstName"
                            prop="firstName" :required='true'> -->
                        <el-form-item class="no-scroll" prop="firstName" :required='true'>
                            <el-input v-model="formsData.userForm.firstName.value" autocomplete="off"
                                :placeholder="pageText[userRole].placeholders.firstName" :maxlength="20"
                                @keyup="formsData.userForm.firstName.value = $event.target.value">
                                <template #prefix>
                                    <i class="el-icon-user"></i>
                                </template>
                            </el-input>
                        </el-form-item>
                        <!-- <el-form-item class="no-scroll" :label="pageText[userRole].placeholders.lastName"
                            prop="lastName" :required='true'> -->
                        <el-form-item class="no-scroll" prop="lastName" :required='true'>
                            <el-input v-model="formsData.userForm.lastName.value" autocomplete="off"
                                :placeholder="pageText[userRole].placeholders.lastName" :maxlength="20"
                                @keyup="formsData.userForm.lastName.value = $event.target.value">
                                <template #prefix>
                                    <i class="el-icon-user"></i>
                                </template></el-input>
                        </el-form-item>
                        

                        <el-form-item class="is-federal" :required="true" label="Are you a federal pharmacist?" v-if="isUS">
                            <el-radio-group v-model="formsData.userForm.federal_pharmacist_support.value">
                                <el-radio :label=1 size="large">Yes</el-radio>
                                <el-radio :label=0 size="large">No</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </template>
                    <el-form-item class="button_submit mb0">

                        <!-- <el-button class="submit" type="blue" @click="save('userForm')"
                            :disabled="(formsData.userForm.disabled || croppedImageUrl === '')">-->
                        <el-button class="submit" type="blue" @click="save('userForm')"
                            :disabled="(formsData.userForm.disabled)">
                            Continue
                        </el-button>
                    </el-form-item>
                </el-form>

                <div class="background-circles" v-if="isAustralia">
                    <div class="circle circle-2"></div>
                    <div class="circle circle-1"></div>
                    <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import PageTitle from '@/components/PageTitle/PageTitle.vue';
import {
    onMounted,
    inject,
    ref,
    getCurrentInstance
} from 'vue';

import {
    addIcons
} from 'ionicons'
import {
    arrowBackOutline
} from 'ionicons/icons'
addIcons({
    'arrow-back-outline': arrowBackOutline
})
import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
} from '@ionic/vue';

import {
    useStore
} from 'vuex'
import {
    Cropper,
    CircleStencil,
    Preview,
    RectangleStencil
} from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import {
    useRouter,
    useRoute
} from 'vue-router'
import formHooks from '@/hooks/form/form'
import formValidate from '@/hooks/form/validate/validate'
// import { UploadFilled } from '@element-plus/icons-vue';
import formMasks from '@/hooks/form/mask/mask'

import IMaskDirective from '@/directives/vue-imask/directive';
import IMask from 'imask/esm/imask';
import SvgIcon from '@/components/Svg/SvgIcon.vue'; 
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';
import { isUSRegion } from '@/helpers/region/regionHelper.js';
export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        Cropper,
        Preview,
        PageTitle,
        SvgIcon
    },
    directives: {
            imask: IMaskDirective
        },
    Components:{
        CircleStencil,
        RectangleStencil,
    },
    setup() {
        const $store = useStore()
        const $router = useRouter()
        const $route = useRoute()
        const setPageClassGlobal = inject(['setPageClassGlobal']);
        const isAustralia = isAustraliaRegion();
        const isUS = isUSRegion();

        const userData = $store.getters.GET_USER_DATA;
        const userRole = userData.role;
        const abn = userData.abn;
        const dialog = ref(false);
        const selectedFile = ref('');
        const mimeType = ref('');
        const croppedImageUrl = ref(null);
        const cropper = ref(null);
        const canvasOriginal = ref();
        const canvasOriginalAll = ref();
        const fileOnload = ref('');
        const pharmacyTypes = $store.getters.pharmacyTypes;
        console.log("🚀 ~ setup ~ pharmacyTypes:", pharmacyTypes)
        const selectedSiteId = ref(null);
        const additionalOptions = ref([]);
        const selectedAdditionalData = ref(null);
        const instance = getCurrentInstance();

        const closeModal = () => {
            dialog.value = false;
            // selectedFile.value = '';
        };

        const pageText = {
            locum: {
                pageTitle: 'Your Name',
                formText: 'Please provide legal full name on your AHPRA registration',
                placeholders: {
                    firstName: 'Please enter your Legal First Name',
                    lastName: 'Please enter your Legal Last Name'
                }
            },
            pharmacy: {
                pageTitle: $route.name == 'auth_billing_name' ? 'Billing Name' : 'Business Name',
                formText: 'What is the name of your company/employer?',
                placeholders: {
                    name: 'Company/Employer Name',
                    businessName: 'Billing Name'
                },

            },
            'job-seeker': {
                pageTitle: 'Your Name',
                formText: 'Please provide legal full name on your AHPRA registration',
                placeholders: {
                    firstName: 'Please enter your Legal First Name',
                    lastName: 'Please enter your Legal Last Name'
                }
            },
        }

        const formsDataArray = {
            userForm: {}
        };

        if (userRole == 'locum') {
            const dataArray = {
                federal_pharmacist_support: {
                    value: userData.firstName || '',
                    resetValue: true,
                },
                firstName: {
                    value: userData.firstName || '',
                    resetValue: true,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'firstName', callback, setFormValidation);
                        },
                    }]
                },

                lastName: {
                    value: userData.lastName || '',
                    resetValue: true,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'lastName', callback, setFormValidation);
                        },
                    }]
                },
                preferred_name: {
                    value: userData?.preferred_name || "",
                },
            }

            // Add federal_pharmacist_support only if a condition is true
            if (isUS.value) { // Replace with your actual condition
                dataArray.federal_pharmacist_support = {
                    value: userData?.federal_pharmacist_support ?? 0,
                    resetValue: true,
                };
            }

            Object.assign(formsDataArray.userForm, dataArray);
        }

        if (userRole == 'job-seeker') {
            const dataArray = {
                firstName: {
                    value: userData.firstName || '',
                    resetValue: true,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'firstName', callback, setFormValidation);
                        },
                    }]
                },

                lastName: {
                    value: userData.lastName || '',
                    resetValue: true,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'lastName', callback, setFormValidation);
                        },
                    }]
                },
                preferred_name: {
                    value: userData?.preferred_name || "",
                },
            }
             // Add federal_pharmacist_support only if a condition is true
             if (isUS.value) { // Replace with your actual condition
                dataArray.federal_pharmacist_support = {
                    value: userData?.federal_pharmacist_support ?? 0,
                    resetValue: true,
                };
            }

            Object.assign(formsDataArray.userForm, dataArray);
        }

        if (userRole == 'pharmacy' && isAustralia.value === true) {
            let dataArray = {}
            if ($route.name == 'auth_billing_name') {
                dataArray = {
                    businessName: {
                        value: userData.billing.name || userData.name,
                        valueTemp: '',
                        disabled: userData.billing.name == userData.name ? true : false,
                        validators: [{
                            validator: (rule, formField, callback) => {
                                formValidate.validate(rule, formField, 'name', callback, setFormValidation);
                            },
                        }]
                    },
                    abn: {
                        value: abn ? IMask.createMask(formMasks.abn).resolve(abn) : '',
                        mask: formMasks.abn,
                        validators: [{
                            validator: (rule, formField, callback) => {
                                formValidate.validate(rule, formField, 'abn', callback, setFormValidation);
                            },
                        }]
                    },
                }
            } else {
                dataArray = {
                    name: {
                        value: userData.name || '',
                        validators: [{
                            validator: (rule, formField, callback) => {
                                formValidate.validate(rule, formField, 'pharmacyName', callback, setFormValidation);
                            },
                        }]
                    },
                    abn: {
                        value: abn ? IMask.createMask(formMasks.abn).resolve(abn) : '',
                        mask: formMasks.abn,
                        validators: [{
                            validator: (rule, formField, callback) => {
                                formValidate.validate(rule, formField, 'abn', callback, setFormValidation);
                            },
                        }]
                    },
                    pharmacyType: {
                        value: userData.siteId || '',
                        validators: [{
                            validator: (rule, formField, callback) => {
                                formValidate.validate(rule, formField, 'pharmacyType', callback, setFormValidation);
                            },
                        }]
                    },
                    additionalData: {
                        value: userData.additionalData || '',
                    } 
                }
            }


            Object.assign(formsDataArray.userForm, dataArray);
        }else{
            if(userRole == 'pharmacy'){
                let dataArray = {}
            if ($route.name == 'auth_billing_name') {
                dataArray = {
                    businessName: {
                        value: userData.billing.name || userData.name,
                        valueTemp: '',
                        disabled: userData.billing.name == userData.name ? true : false,
                        validators: [{
                            validator: (rule, formField, callback) => {
                                formValidate.validate(rule, formField, 'name', callback, setFormValidation);
                            },
                        }]
                    },
                }
            } else {
                dataArray = {
                    name: {
                        value: userData.name || '',
                        validators: [{
                            validator: (rule, formField, callback) => {
                                formValidate.validate(rule, formField, 'pharmacyName', callback, setFormValidation);
                            },
                        }]
                    },
                    pharmacyType: {
                        value: userData.siteId || '',
                        validators: [{
                            validator: (rule, formField, callback) => {
                                formValidate.validate(rule, formField, 'pharmacyType', callback, setFormValidation);
                            },
                        }]
                    },
                    additionalData: {
                        value: userData.additionalData || '',
                    } // Placeholder for dynamic validation
                }
                
            }
            Object.assign(formsDataArray.userForm, dataArray);
            }
        }

        const onNameCheckboxChange = () => {
            if (formsData.userForm.businessName.disabled) {
                formsData.userForm.businessName.valueTemp = formsData.userForm.businessName.value;
                formsData.userForm.businessName.value = userData.name
                formsData.userForm.businessName.disabled = true;
                console.log(true);
            } else {
                formsData.userForm.businessName.value = formsData.userForm.businessName.valueTemp;
                formsData.userForm.businessName.disabled = false;
                console.log(false);
            }
            checkFormValidation('userForm', true, 'businessName');
        };

        const goBack = () => {
            $store.dispatch('AUTH_LOGOUT')
        };

        const goNext = () => {
            if (userRole == 'locum') {
                if(isAustralia.value){
                    $router.push({
                        name: 'auth_birthday',
                    })

                }else{

                    $router.push({
                        name: 'platform_role',
                    })
                }
            } else if (userRole == 'job-seeker') {
                console.log('seeeejer');
                $router.push({
                    name: 'jobseeker_auth_address',
                })
            } else {
                if (instance?.appContext.config.globalProperties.$filters.employerType(userData).isValid && instance?.appContext.config.globalProperties.$filters.employerType(userData).isCommunityPharmacy) {
                    $router.push({
                        name: 'additional_name',
                    })
                } else if (!instance?.appContext.config.globalProperties.$filters.employerType(userData).isValid || instance?.appContext.config.globalProperties.$filters.employerType(userData).isHospitalPharmacy) {
                    $router.push({
                        name: 'employer_additional_information',
                    })
                } else if (instance?.appContext.config.globalProperties.$filters.employerType(userData)) { // for healshifts checks
                    $router.push({
                        name: 'additional_name',
                    })
                } else {
                    $router.push({
                        name: 'employer_additional_information',
                    })
                }
            }
        };

        const skip = () => {
            $store.dispatch('addAuthPageBack', $route.name);
            goNext()
        }

        const save = async (formName) => {
            try {
               
               
                
                // Perform form validation
                formsRefs[formName].value.validate(async () => {
                        // Collect other form data
                        const form = new FormData();


                        let siteId = null;
                        // console.log("🚀 ~ save ~ siteId:", siteId)

                        if (userRole == 'pharmacy') {
                            siteId = additionalOptions.value.length > 0 && formsData.userForm.additionalData.value
                            ? formsData.userForm.additionalData.value
                            : formsData.userForm.pharmacyType.value;
                            console.log("🚀 ~ formsRefs[formName].value.validate ~ siteId:", siteId)

                                form.append('site_id', siteId);

                        }
                        const otherFormData = getFormValues(formName);


                        

                        for (const key in otherFormData) {
                            let newKey = key;
                                if(key === 'siteId') {
                                    newKey = 'site_id';
                                }
                                form.append(newKey, otherFormData[key]);
                        }
                        // if(instance?.appContext.config.globalProperties.$filters.employerType(userData)){
                        // form.append('site_id', siteId);
                        // }
                        if (croppedImageUrl.value) {
                            console.log("🚀 ~ formsRefs[formName].value.validate ~ croppedImageUrl.value:", croppedImageUrl.value)
                            if (canvasOriginal.value) {
                                canvasOriginal.value.toBlob(async (blob) => {
                                    form.append('image', blob);

                                    // Simulate saving user data
                                    try {

                                        if (userRole == 'job-seeker') {
                                            await $store.dispatch('SAVE_JOB_SEEKER_NAME', form);
                                        } else {
                                            await $store.dispatch('SAVE_USER_DATA', form);
                                        }
                                        goNext();
                                    } catch (error) {
                                        console.error('Error submitting form:', error);
                                    }
                                }, mimeType.value);
                            } else {
                                console.error('Error: canvas is not available.');
                            }
                        } else {
                            try {
                                if (userRole == 'job-seeker') {
                                    await $store.dispatch('SAVE_JOB_SEEKER_NAME', form);
                                } else {
                                    await $store.dispatch('SAVE_USER_DATA', form);
                                }
                                    
                                goNext();
                            } catch (error) {
                                console.error('Error submitting form:', error);
                            }
                        }

                   
                });
            } catch (error) {
                console.error('Error in save function:', error);
            }
        };


        onMounted(() => {
            setPageClassGlobal('global_auth_page');
            setFormRefs();
            formsRefs.userForm.value.$el[0].focus();
            // set default pharmacy type to Community Pharmacy
            // const defaultPharmacyType = pharmacyTypes.filter((pharmacyType) => pharmacyType.name === 'Community Pharmacy');
            // if (defaultPharmacyType.length && 
            //     userRole === 'pharmacy' && 
            //     isUS.value === true && 
            //     !formsData.userForm.pharmacyType.value &&
            //     $route.name != 'auth_billing_name'
            // ) {
            //     // formsData.userForm.siteId.value = defaultPharmacyType[0].id;
            //     //trigger select change event to validate the field
            //     formsRefs.userForm.value.$children[1].$el.dispatchEvent(new Event('change'));
            // }
            checkFormValidation('userForm', false);
        });

        const cropImage = () => {
            const result = cropper.value.getResult();
            if (result && result.canvas) {
                canvasOriginalAll.value = result;
                canvasOriginal.value = result.canvas;
                croppedImageUrl.value = result.canvas.toDataURL();
            }
            dialog.value = false;
        };


        const onFileSelect = (e) => {
            fileOnload.value = e.target.files[0];
            mimeType.value = fileOnload.value.type;
            if (FileReader) {
                dialog.value = true;
                const reader = new FileReader();
                reader.onload = (event) => {
                    selectedFile.value = event.target.result;
                };
                reader.readAsDataURL(fileOnload.value);
            } else {
                alert('Sorry, FileReader API not supported');
            }
        };

        const fetchAdditionalData = async () => {

            try {
                delete formsDataArray.userForm.additionalData.validators;

                const response = await $store.dispatch("GET_PHARMACY_SUB_TYPES", {
                    siteId: formsData.userForm.pharmacyType.value
                });

                if (response && response.length) {
                    additionalOptions.value = response;
                    formsDataArray.userForm.additionalData.validators = [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(rule, formField, "additionalData", callback, setFormValidation);
                            }
                        }
                    ];
                    checkFormValidation('userForm', true, 'additionalData');

                } else {
                    additionalOptions.value = [];
                }
            } catch (error) {
                console.error("Error fetching additional data:", error);
                additionalOptions.value = [];
               
            }
            formHooks(formsDataArray);
        };

        // watch(selectedSiteId, fetchAdditionalData);

        // Watch for changes in additionalOptions and update validation dynamically
        // watch(additionalOptions, (newOptions) => {
        //     console.log("🚀 ~ watch ~ newOptions:", newOptions)
        //     if (newOptions.length > 0) {
        //         // Add validation for additionalData if options exist
              
               
               
        //     } else {
        //         // Remove validation if no options are available
        //         delete formsDataArray.userForm.additionalData.validators;
        //     }
        // });

        const {
            onFormMaskAccept,
            checkFormValidation,
            setFormValidation,
            getFormValues,
            setFormRefs,
            formsData,
            formsRefs,
        } = formHooks(formsDataArray);

        return {
            formsData,
            goBack,
            save,
            skip,
            userRole,
            pageText,
            onNameCheckboxChange,
            dialog,
            selectedFile,
            mimeType,
            croppedImageUrl,
            cropper,
            onFileSelect,
            cropImage,
            closeModal,
            canvasOriginal,
            canvasOriginalAll,
            checkFormValidation,
            onFormMaskAccept,
            isAustralia,
            isUS,
            pharmacyTypes,
            selectedSiteId,
            additionalOptions,
            selectedAdditionalData,
            fetchAdditionalData,
            instance
        }
    },
}
</script>
